"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.QUOTE_CARDS = void 0;

require("./QuoteSelector.css");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QUOTE_CARDS = {
  FINCORE: 0,
  SLP: 1,
  CSU: 2
};
exports.QUOTE_CARDS = QUOTE_CARDS;
var quoteData = [{
  quoteImage: require("../assets/redesign2020/quote-selector/quote-fincore.png"),
  chevron: require("../assets/redesign2020/quote-selector/fincore-chevron.svg"),
  quote: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "When this program was announced, I felt a sigh of relief that I wasn\u2019t alone with student debt. ", /*#__PURE__*/_react.default.createElement("span", {
    className: "highlighted"
  }, "It has truly made me appreciate our company and leadership team"), " so much more. They truly care about our health and financial well-being.\""),
  quoter: "Devon F., FinancialCore participant",
  className: "fincore"
}, {
  quoteImage: require("../assets/redesign2020/quote-selector/quote-slp.png"),
  chevron: require("../assets/redesign2020/quote-selector/slp-chevron.svg"),
  quote: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "highlighted"
  }, "This has been a great benefit"), ", not just financially, but also mentally, knowing that I'm finally making progress on my loans.\""),
  quoter: "Rebecca A., Student Loan PayDown participant",
  className: "slp"
}, {
  quoteImage: require("../assets/redesign2020/quote-selector/quote-csu.png"),
  chevron: require("../assets/redesign2020/quote-selector/csu-chevron.svg"),
  quote: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "I'm grateful to even have the option to enroll in this benefit. It shows that my employer understands the importance of saving for higher education. ", /*#__PURE__*/_react.default.createElement("span", {
    className: "highlighted"
  }, "It is one of the reasons why I haven't even considered a new career or relocating"), ".\""),
  quoter: "Ashely L., College SaveUp Participant",
  className: "csu"
}];

var _default = function _default(_ref) {
  var defaultQuote = _ref.defaultQuote;
  var _quoteData$defaultQuo = quoteData[defaultQuote],
      className = _quoteData$defaultQuo.className,
      quoteImage = _quoteData$defaultQuo.quoteImage,
      chevron = _quoteData$defaultQuo.chevron,
      quote = _quoteData$defaultQuo.quote,
      quoter = _quoteData$defaultQuo.quoter;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("quote-selector", className)
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "",
    src: quoteImage,
    className: "quote-selector-image"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "quote-body-wrapper"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "quote-selector-quote"
  }, "\u201C"), /*#__PURE__*/_react.default.createElement("div", {
    className: "quote-body"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: "",
    src: chevron,
    className: "quote-chevron"
  }), /*#__PURE__*/_react.default.createElement("h3", {
    className: "quote-text"
  }, quote), /*#__PURE__*/_react.default.createElement("p", {
    className: "quoter"
  }, quoter))));
};

exports.default = _default;